import { observer } from "mobx-react";
import { useRef } from "react";
import { useStore } from "../../app/stores/store";
import NewHeader from "@/features/header/Header";
import { OMSDiaryNoteItem } from "@/app/common/common-components/OMSDiaryNoteComponents/OMSDiaryNoteItem";
import { useQuery } from "@tanstack/react-query";
import apiAgent from "@/app/api/apiAgent";

export default observer(function HeaderWrapper() {
  const {
    userStore: { userSession, logout, logoutAs, isLoggedIn },
  } = useStore();
  const noteItemRef = useRef<any>(null);

  const onNewEventClick = () => {
    if (noteItemRef.current) {
      noteItemRef.current.onOpenDairyNoteItem(null);
    }
  };

  const adminRoles = ["entegralsuperuser", "groupadministrator", "officeadministrator"];

  const enabledModules = Array.from(userSession?.enabledModules ?? []);

  const { data: library } = useQuery({
    queryKey: ["library"],
    queryFn: () => apiAgent.Library.getLibrary(),
  });

  return (
    <>
      <NewHeader
        displayName={userSession?.displayName ?? ""}
        modules={enabledModules}
        userId={userSession?.userId}
        logout={() => {
          if (userSession?.isLoginAs) {
            logoutAs();
          } else {
            logout();
          }
        }}
        isLoginAs={userSession?.isLoginAs}
        onNewEventClick={onNewEventClick}
        systemLogo={userSession?.systemLogo}
        isAdmin={adminRoles.includes(userSession?.role?.toLowerCase() ?? "")}
        isReadOnly={userSession?.role?.includes("ViewOnly")}
        noticeBoardAccess={library?.content_access}
      />
      <OMSDiaryNoteItem
        ref={noteItemRef}
        htmlID="noteItemDashboard"
        ID="noteItemDashboard"
        IsReadOnly={userSession?.role == "StandardUserViewOnly"}
        OnShowStart={userSession?.headerValues?.onShowStart}
        OnShowEnd={userSession?.headerValues?.onShowEnd}
        DNType={0}
        DiaryActionTags={userSession?.headerValues?.diaryActionTags}
      />
    </>
  );
});
